import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
} from "@mui/material";
import { useTheme } from '../contexts/ThemeContext';
import { useKeyboardScroll } from '../hooks/useKeyboardScroll';
import SignUpPage from './SignUpPage';
import LoginForm from '../components/LoginForm';

const LoginPage: React.FC = () => {
  const [showSignUp, setShowSignUp] = useState(false);

  const { theme } = useTheme();

  // Hook para scroll automático quando teclado aparecer (Capacitor)
  useKeyboardScroll();

  const TOP_CARD_HEIGHT = "70%";

  if (showSignUp) {
    return <SignUpPage onBack={() => setShowSignUp(false)} />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        bgcolor: theme.colors.primary,
        overflow: "hidden",
      }}
    >
      {/* Card branco superior com cantos inferiores arredondados */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: TOP_CARD_HEIGHT,
          bgcolor: theme.colors.background,
          borderBottomLeftRadius: 28,
          borderBottomRightRadius: 28,
        }}
      >
        {/* Logo decorativa cortada no canto superior esquerdo */}
        <img
          src="/hostly-02.png"
          alt="Logo decorativa"
          style={{
            position: "absolute",
            top: -35,
            left: -80,
            width: 280,
            opacity: 0.8,
            transform: "rotate(15deg)"
          }}
        />

        {/* Logo decorativa cortada no canto inferior direito */}
        <img
          src="/hostly-02.png"
          alt="Logo decorativa"
          style={{
            position: "absolute",
            bottom: 20,
            right: -80,
            width: 280,
            opacity: 0.6
          }}
        />

        {/* Logo principal centralizada */}
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img
              src="/hostly_Prancheta 1.png"
              alt="Hostly Logo"
              style={{
                height: "auto",
                maxHeight: "280px",
                width: "auto",
                maxWidth: "280px",
                animation: "pulse 3s ease-in-out infinite"
              }}
            />
            <Typography
              sx={{
                color: theme.colors.primary,
                fontWeight: "600",
                fontSize: "1.1rem",
                fontFamily: "'Montserrat', sans-serif",
                marginTop: "-60px",
                letterSpacing: "0.05em",
              }}
            >
              SEU LAR NO CELULAR
            </Typography>
          </Box>
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
            
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
                opacity: 1;
              }
              50% {
                transform: scale(1.05);
                opacity: 0.85;
              }
            }
          `}</style>
        </Box>
      </Box>

      {/* CONTÊINER DO FORMULARIO POSICIONADO ENTRE O BRANCO E O MARROM */}
      <Paper
        elevation={0}
        sx={{
          position: "absolute",
          left: 24,
          right: 24,
          top: TOP_CARD_HEIGHT,
          transform: "translateY(-22%)",
          mx: "auto",
          width: { xs: "calc(100% - 48px)", sm: 420 },
          maxWidth: 440,
          px: 4,
          py: 2.5,
          borderRadius: 2,
          bgcolor: "#eef3f7",
          zIndex: 2,
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(0, 0, 0, 0.05)",
        }}
      >
        <LoginForm onSignUpClick={() => setShowSignUp(true)} />
      </Paper>
    </Box>
  );
};

export default LoginPage;
